<template>
  <LazyModal
    no-cancel
    :tracking="{
      topicKey: 'legacy-browser-warning',
    }"
    @confirm="emit('confirm')"
  >
    <template #headline>
      {{ $t('restriction.legacybrowser.title') }}
    </template>
    <article class="flex flex-col gap-200">
      <p>
        {{ $t('restriction.legacybrowser.text.intro') }}
      </p>
      <i18n-t v-if="hintKeys" :keypath="hintKeys[0]" tag="p">
        <template #path>
          <strong class="paragraph-bold">
            {{ $t(hintKeys[1]) }}
          </strong>
        </template>
      </i18n-t>
      <p v-else />
      <p>
        {{ $t('restriction.legacybrowser.text.outro') }}
      </p>
    </article>
    <template #confirm>
      {{ $t('restriction.legacybrowser.cta') }}
    </template>
  </LazyModal>
</template>

<script lang="ts" setup>
const emit = defineEmits<{ confirm: [] }>()

const { isAndroid, isDesktop, isIos, isMacOS, isMobile } = useDevice()

const hintKeys = computed(() => {
  if (isIos)
    return [
      'restriction.legacybrowser.text.hint.ios',
      'restriction.legacybrowser.text.hint.ios.path',
    ] as const

  if (isMacOS)
    return [
      'restriction.legacybrowser.text.hint.macos',
      'restriction.legacybrowser.text.hint.macos.path',
    ] as const

  if (isAndroid)
    return [
      'restriction.legacybrowser.text.hint.android',
      'restriction.legacybrowser.text.hint.android.path',
    ] as const

  if (isMobile)
    return [
      'restriction.legacybrowser.text.hint.mobile',
      'restriction.legacybrowser.text.hint.mobile.path',
    ] as const

  if (isDesktop)
    return [
      'restriction.legacybrowser.text.hint.desktop',
      'restriction.legacybrowser.text.hint.desktop.path',
    ] as const
})
</script>
